import { IBuildingDetail } from 'spw-redux/modules/building-detail/types';
import { Actions, SET_CURRENT_VIEW } from './actions';
import {
  CLEAN_UP_CURRENT_PROJECT,
  cleanUpCurrentProject,
} from '../projects/actions';

const initialState: IBuildingDetail = {
  currentView: '',
  nextView: '',
};

const reducer = (
  state: IBuildingDetail = initialState,
  action: Actions | ReturnType<typeof cleanUpCurrentProject>
) => {
  switch (action.type) {
    case SET_CURRENT_VIEW:
      return { ...state, currentView: action.payload.currentView };

    case CLEAN_UP_CURRENT_PROJECT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
